module.exports = __webpack_public_path__ + "img/code.714f27cb.png";